var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    rx: 6,
    fill: "#6C5DD3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.248 15.3795C11.248 15.7937 11.5838 16.1295 11.998 16.1295C12.4123 16.1295 12.748 15.7937 12.748 15.3795V12.741H15.3863C15.8005 12.741 16.1363 12.4052 16.1363 11.991C16.1363 11.5768 15.8005 11.241 15.3863 11.241H12.748V8.60257C12.748 8.18836 12.4123 7.85257 11.998 7.85257C11.5838 7.85257 11.248 8.18836 11.248 8.60257V11.241H8.60937C8.19516 11.241 7.85938 11.5768 7.85938 11.991C7.85938 12.4052 8.19516 12.741 8.60937 12.741H11.248V15.3795Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddActive);
export default __webpack_public_path__ + "static/media/add-active.6f8be697b6570893c9c0648aa527936b.svg";
export { ForwardRef as ReactComponent };